module.exports = __webpack_public_path__ + "static/Fabriga-Medium-6c8787bc851e71eb1f97285560204b5c.woff";